export const env = {
  url: process.env.REACT_APP_BASE_URL || '/api',
  ttl: JSON.parse(process.env.REACT_APP_TTL_SECONDS || '60'),
};